module.exports = __webpack_public_path__ + "img/Secondary-chevron.4fb29692.svg";